import React from "react";

import { Skeleton } from "@common/skeleton";

import { Props } from "./types";
import styles from "./styles.scss";

function Loader({ style = {} }: Props) {
  const indentSize =
    typeof style?.indentSize === "number" ? `${style.indentSize}px` : "3.5rem";

  return (
    <div className={styles.loader}>
      {new Array(3).fill(0).map((_, index) => (
        <Skeleton
          key={index}
          className={styles.projectElement}
          style={{
            ...(index % 3 !== 0 && index !== 0 && { marginLeft: indentSize }),
            ...(typeof style.itemHeight !== "undefined" && {
              height: style.itemHeight,
            }),
          }}
        />
      ))}
    </div>
  );
}

export { Loader };
